import { Input } from 'style-guide/Input';
import RadioButtons from './RadioButtons';

const fields = ({ register, control }) => [
  {
    name: 'email',
    label: 'E-mail',
    required: true,
    component: <Input name='email' required {...register('email')} />,
  },
  {
    name: 'userName',
    label: 'Username',
    required: false,
    component: <Input name='userName' {...register('userName')} />,
  },
  {
    name: 'firstName',
    label: 'First Name',
    required: false,
    component: <Input name='firstName' {...register('firstName')} />,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    required: false,
    component: <Input name='lastName' {...register('lastName')} />,
  },
  {
    name: 'password',
    label: 'Password',
    required: true,
    component: <Input name='password' required {...register('password')} />,
  },
  {
    name: 'confirmPassword',
    required: true,
    label: 'Confirm Password',
    component: <Input name='confirmPassword' required {...register('confirmPassword')} />,
  },
  {
    name: 'accessType',
    label: 'User access type',
    component: <RadioButtons control={control} />,
  },
];

export default fields;
